import styled, { css } from 'styled-components';
import { Box, Label } from '@scope/scope-one-ui/core';
import { SIZES } from '@scope/scope-one-ui/theme';
import { DotProps } from '../types/esgSentiment';
import { groupColors } from '../utils/groupColors';

export const SectionA = styled(Box)`
  display: grid;
  grid-gap: ${SIZES.spacing(5.5)};
  grid-template-columns: 2fr 3fr 3fr;
`;

export const SentimentLabel = styled(Label)`
  > div {
    width: ${SIZES.spacing(12)};
    justify-content: center;
  }
`;

export const Dot = styled(Box)<DotProps>(
  ({ groupType }) => css`
    border-radius: 50%;
    flex-shrink: 0;
    width: ${SIZES.spacing(1.5)};
    height: ${SIZES.spacing(1.5)};
    background-color: ${groupColors[groupType]};
  `,
);
